import { allCountries } from "country-telephone-data";
import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";
// Components
import Input from "../Input";
import CountryDropdown from "../CountryListDropdown";
import Select from "../Select";

const EmergencyContactDetails = ({
  formData,
  handleChange,
  formErrors,
  inputRefs,
}) => {
  // Register the locale
  countries.registerLocale(enLocale);

  // Get the country list in English
  const countryOptions = Object.entries(countries.getNames("en")).map(
    ([code, name]) => ({
      label: name,
      value: name,
    }),
  );

  return (
    <div className="grid md:grid-cols-2 gap-4">
      <Input
        label="First Name"
        name="ecFirstName"
        value={formData.ecFirstName}
        onChange={handleChange}
        ref={inputRefs.ecFirstName}
        // error={formErrors.ecFirstName}
      />
      <Input
        label="Last Name"
        name="ecLastName"
        value={formData.ecLastName}
        onChange={handleChange}
        ref={inputRefs.ecLastName}
        // error={formErrors.ecLastName}
      />
      <div className="md:col-span-3">
        <div className="grid md:grid-cols-2 gap-4">
          <Select
            label="Country Code"
            name="ecCountryCode"
            ref={inputRefs.ecCountryCode}
            value={formData.ecCountryCode}
            onChange={handleChange}
            placeholder="Select a country code"
            searchable={true} // ADD THIS LINE ONLY
            options={allCountries.map((country) => ({
              label: `+${country.dialCode} ${country.name}`,
              value: `+${country.dialCode} ${country.name}`,
            }))}
          />
          <Input
            label="Phone Number"
            name="ecPhone"
            value={formData.ecPhone}
            onChange={handleChange}
            ref={inputRefs.ecPhone}
          />
        </div>
      </div>

      {/* Custom Tailwind dropdown for Country */}
      <CountryDropdown
        name="ecCountry"
        value={formData.ecCountry}
        onChange={handleChange}
        options={countryOptions}
        className="md:col-span-1"
        ref={inputRefs.ecCountry}
      />
    </div>
  );
};

export default EmergencyContactDetails;
